import { render, staticRenderFns } from "./MenuDropdown.vue?vue&type=template&id=56c8ee34&scoped=true&"
import script from "./MenuDropdown.vue?vue&type=script&lang=js&"
export * from "./MenuDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MenuDropdown.vue?vue&type=style&index=0&id=56c8ee34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8ee34",
  null
  
)

export default component.exports